import React from 'react'
import styled from 'styled-components'

import colors from 'styles/colors'
import text from 'styles/text'
import media from 'styles/media'

import links from 'utils/links'

import LogoSVG from 'assets/images/logo.svg'
import { ReactComponent as DiscordSVG } from 'assets/images/icons/discord.svg'
import { ReactComponent as TwitterSVG } from 'assets/images/icons/twitter.svg'
import { ReactComponent as InstagramSVG } from 'assets/images/icons/instagram.svg'
import { ReactComponent as MediumSVG } from 'assets/images/icons/medium.svg'

const Footer: React.FC = () => {

  const handleSocialClick = (href: string) => {
    window.open(href, "_blank", "noopener,noreferer")
  }

  return (
    <Wrapper>
      <Top>
        <Logo src={LogoSVG} alt="FreshCut Logo" loading="lazy"/>
        <Row>
          <Discord onClick={() => handleSocialClick(links.discord)}/>
          <Twitter onClick={() => handleSocialClick(links.twitter)}/>
          <Instagram onClick={() => handleSocialClick(links.instagram)}/>
          <Medium onClick={() => handleSocialClick(links.medium)}/>
        </Row>
      </Top>
      <HR/>
      <Bottom>
        <P> &#169; 2022 FreshCut</P>
        <Row>
          <A href={links.home}>Terms <Line/></A>
          <A href={links.home}>Privay Policy <Line/></A>
        </Row>
      </Bottom>
    </Wrapper>
  )
}

export default Footer

const Wrapper = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: column;

  height: 13.89vw;
  padding-left: 4.17vw;
  padding-right: 4.17vw;

  ${media.tablet} {
    height: 19.53vw;
    padding-left: 5.86vw;
    padding-right: 5.86vw;
  }

  ${media.mobile} {
    height: 48.533vw;
    padding-left: 4vw;
    padding-right: 4vw;
  }
`

const Row = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`

const Social = `
  cursor: pointer;

  width: 1.74vw;
  height: 1.74vw;

  ${media.tablet} {
    width: 2.44vw;
    height: 2.44vw;
  }

  ${media.mobile} {
    width: 6.667vw;
    height: 6.667vw;
    top: 0;
  }

  path {
    transition: 500ms;
  }

  ${media.hover} {
    &:hover {
      path {
        fill: url(#verticalGradient);
      }
    }
  }
`

const Discord = styled(DiscordSVG)`
  ${Social}
`

const Twitter = styled(TwitterSVG)`
  ${Social}
`

const Instagram = styled(InstagramSVG)`
  ${Social}
`

const Medium = styled(MediumSVG)`
  ${Social}
`

const Top = styled(Row)`
  display: flex;
  align-items: center;
  
  ${Row} {
    width: 11.11vw;

    ${media.tablet} {
      width: 15.63vw;
    }

    ${media.mobile} {
      width: 42.667vw;
    }
  }
`

const Logo = styled.img`
  width: 17.22vw;
  height: 1.81vw;

  ${media.tablet} {
    width: 24.22vw;
    height: 2.54vw;
  }

  ${media.mobile} {
    width: 34.4vw;
    height: 3.733vw;
  }
`

const HR = styled.div`
  width: 100%;
  height: 1px;
  background: ${colors.horzGradient};

  margin-top: 3.47vw;
  margin-bottom: 1.39vw;

  ${media.tablet} {
    width: 88.281vw;
    height: 0.195vw;
    margin-top: 4.88vw;
    margin-bottom: 1.95vw;
  }

  ${media.mobile} {
    width: 92vw;
    height: 0.533vw;
    margin: 13.6vw 0 5.333vw;
  }
`

const Bottom = styled(Row)`
  ${Row} {
    width: 12vw;

    ${media.tablet} {
      width: 16vw;
    }

    ${media.mobile} {
      width: 43.2vw;
    }
  }
`

const textStyles = `
  ${text.desktop.bodyS}
  color: ${colors.black25};

  ${media.tablet} {
    ${text.tablet.bodyS}
  }

  ${media.mobile} {
    ${text.mobile.bodyS}
  }
`

const P = styled.p`
  ${textStyles}

  ${media.mobile} {
    width: 31.467vw;
    margin-right: 17.333vw;
  }
`

const Line = styled.div`
  height: 1px;
  width: 0%;
  transition: 500ms;
  background-color: ${colors.pureWhite};
`

const A = styled.a`
  ${textStyles}
  text-decoration: none;

  &:hover {
    color: ${colors.pureWhite};

    ${Line} {
      width: 100%;
    }
  }
`